export class FindAllOrganisationMembers {
  public static readonly type =
    '[Organisation/OrganisationMember/List] FindAllOrganisationMembers';
}
